import React from "react";

/**
 * Split total seconds into display parts matching session/exercise duration format.
 */
export function getDurationMetricParts(totalSec) {
  const sec = Math.max(0, Math.round(Number(totalSec) || 0));
  if (sec <= 0) return [];
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  const parts = [];
  if (h > 0) {
    parts.push({ value: h, unit: "h" });
    if (m > 0 || s > 0) parts.push({ value: m, unit: "m" });
    if (s > 0) parts.push({ value: s, unit: "s" });
    return parts;
  }
  if (m > 0) {
    parts.push({ value: m, unit: "m" });
    if (s > 0) parts.push({ value: s, unit: "s" });
    return parts;
  }
  parts.push({ value: s, unit: "s" });
  return parts;
}

/** One-line duration with compact h/m/s unit labels. */
export function DurationMetricValue({
  totalSec,
  empty = "—",
  className = "duration-metric-value",
}) {
  const parts = getDurationMetricParts(totalSec);
  if (!parts.length) return empty;
  return (
    <span className={className}>
      {parts.map((part, index) => (
        <span key={`${part.unit}-${index}`} className="duration-metric-value__part">
          <span className="duration-metric-value__num">{part.value}</span>
          <span className="duration-metric-value__unit">{part.unit}</span>
        </span>
      ))}
    </span>
  );
}

export default DurationMetricValue;
